import {axiosV3} from "../../Utils/Axios/axiosV3";

export const getLessons_Service = async (userToken: string): Promise<any> => {
  return axiosV3.post(
    "/user_lessons",
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
